import { BlackboxFieldValidityTypes, FormDataType } from '@tn/formbuilder/utils/schema-types';

export const cleanFormData = (formData: FormDataType) =>
    Object.fromEntries(
        Object.entries(formData).filter(([_, value]) => value !== BlackboxFieldValidityTypes.valid),
    );
